import { render } from "./ProxyPage.vue?vue&type=template&id=4337f0e5&scoped=true"
import script from "./ProxyPage.vue?vue&type=script&lang=js"
export * from "./ProxyPage.vue?vue&type=script&lang=js"

import "./ProxyPage.vue?vue&type=style&index=0&id=4337f0e5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4337f0e5"]])

export default __exports__